export const u8_to_utf8 = u8 =>
  new TextDecoder('utf-8').decode(u8)

export const utf8_to_u8 = utf8 =>
  new TextEncoder('utf-8').encode(utf8)

export const utf8_to_u8_nfkc = utf8 =>
  utf8_to_u8(utf8.normalize('NFKC'))

